import type { ReactNode } from "react"
import { Button, Flex } from "antd"
import { HolderOutlined } from "@ant-design/icons"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import classNames from "classnames"
import styles from "./index.css"

type SortableCategoryRowProps = {
  category: string
  disabled: boolean
  children: ReactNode
}

export const SortableCategoryRow = ({
  category,
  disabled,
  children,
}: SortableCategoryRowProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: category, disabled })

  return (
    <Flex
      ref={setNodeRef}
      className={classNames(
        styles.categoryRow,
        isDragging && styles.categoryDragging,
      )}
      style={{ transform: CSS.Translate.toString(transform), transition }}
      gap={8}
      align="center"
    >
      <Button
        ref={setActivatorNodeRef}
        {...attributes}
        {...listeners}
        type="text"
        size="small"
        className={styles.dragHandle}
        icon={<HolderOutlined />}
        aria-label={`拖动分类 ${category} 排序`}
        title="拖动排序；也可按空格开始，用上下方向键调整，再按空格放置"
        disabled={disabled}
      />
      {children}
    </Flex>
  )
}
